import { createContext, useContext, ReactNode } from 'react';

interface WsStatusContextType {
  /** True when the WebSocket connection is authenticated and active. */
  wsConnected: boolean;
}

const WsStatusContext = createContext<WsStatusContextType>({ wsConnected: false });

interface WsStatusProviderProps {
  wsConnected: boolean;
  children: ReactNode;
}

export function WsStatusProvider({ wsConnected, children }: WsStatusProviderProps) {
  return (
    <WsStatusContext.Provider value={{ wsConnected }}>
      {children}
    </WsStatusContext.Provider>
  );
}

export function useWsStatus(): WsStatusContextType {
  return useContext(WsStatusContext);
}
